import { useEffect, useState } from 'react';

const BackgroundEffects = () => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="fixed inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Gradient Mesh - Animated orbs */}
      <div className="absolute inset-0">
        {/* Primary gold orb - top left */}
        <div
          className={`absolute w-[800px] h-[800px] rounded-full transition-opacity duration-1000 ${
            mounted ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'radial-gradient(circle, rgb(var(--color-primary) / 0.12) 0%, transparent 70%)',
            top: '-20%',
            left: '-10%',
            filter: 'blur(80px)',
            animation: 'float-slow 35s ease-in-out infinite',
          }}
        />

        {/* Accent copper orb - right side */}
        <div
          className={`absolute w-[600px] h-[600px] rounded-full transition-opacity duration-1000 delay-200 ${
            mounted ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'radial-gradient(circle, rgb(var(--color-accent) / 0.08) 0%, transparent 70%)',
            top: '30%',
            right: '-15%',
            filter: 'blur(100px)',
            animation: 'float-slow 40s ease-in-out infinite reverse',
            animationDelay: '5s',
          }}
        />

        {/* Secondary gold orb - bottom */}
        <div
          className={`absolute w-[700px] h-[700px] rounded-full transition-opacity duration-1000 delay-500 ${
            mounted ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'radial-gradient(circle, rgb(var(--color-primary) / 0.06) 0%, transparent 70%)',
            bottom: '-25%',
            left: '20%',
            filter: 'blur(120px)',
            animation: 'float-slow 45s ease-in-out infinite',
            animationDelay: '10s',
          }}
        />

        {/* Subtle purple/dark accent - center */}
        <div
          className={`absolute w-[500px] h-[500px] rounded-full transition-opacity duration-1000 delay-700 ${
            mounted ? 'opacity-100' : 'opacity-0'
          }`}
          style={{
            background: 'radial-gradient(circle, rgb(80 60 120 / 0.05) 0%, transparent 70%)',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            filter: 'blur(100px)',
            animation: 'glow-breathe 12s ease-in-out infinite',
          }}
        />
      </div>

      {/* Grain overlay */}
      <div
        className="absolute inset-0 opacity-[0.015] dark:opacity-[0.025]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noise'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noise)'/%3E%3C/svg%3E")`,
          animation: 'grain 8s steps(10) infinite',
        }}
      />

      {/* Subtle vignette effect */}
      <div
        className="absolute inset-0"
        style={{
          background: 'radial-gradient(ellipse at center, transparent 0%, rgb(var(--color-background) / 0.4) 100%)',
        }}
      />

      {/* Floating particles */}
      <div className="absolute inset-0">
        {[...Array(12)].map((_, i) => (
          <div
            key={i}
            className={`absolute rounded-full transition-opacity duration-1000 ${
              mounted ? 'opacity-100' : 'opacity-0'
            }`}
            style={{
              width: `${2 + Math.random() * 3}px`,
              height: `${2 + Math.random() * 3}px`,
              background: `rgb(var(--color-primary) / ${0.15 + Math.random() * 0.15})`,
              left: `${10 + Math.random() * 80}%`,
              top: `${10 + Math.random() * 80}%`,
              animation: `float-organic ${20 + Math.random() * 15}s ease-in-out infinite`,
              animationDelay: `${Math.random() * 10}s`,
              transitionDelay: `${i * 100}ms`,
            }}
          />
        ))}
      </div>

      {/* Top gradient fade */}
      <div
        className="absolute top-0 left-0 right-0 h-32"
        style={{
          background: 'linear-gradient(to bottom, rgb(var(--color-background)), transparent)',
        }}
      />
    </div>
  );
};

export default BackgroundEffects;
